import React, { useState, useEffect } from 'react';
import {DeliveryType} from '../../constants/deliveryTypes';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {withTranslation} from 'react-i18next';

const OptionEatIn = ({ onSelectType, chooseDeliveryType, taAdditionalClass, branchInfo, t }) => {
  return (
    <div
      className={`switcher-option eat-in-option ${taAdditionalClass}`}
      onClick={ ()=> {
        onSelectType(DeliveryType.EAT_IN);
      }}
    >
      <div className={'title'}>
        { branchInfo.use_pin_pad_flg === 0 ? t('delivery_type_switcher.eatIn.title') : t('delivery_type_switcher.eatIn.title_kiosk') }
      </div>
      <div className={'switcher-logo'}>
        &nbsp;
      </div>      
      <div className={'details-content'}>

        <div className={'start-btn-block'}>
          <div
            className={'start-btn'}
            onClick={ chooseDeliveryType }
          >
            <FontAwesomeIcon icon="sign-in-alt"  />
          </div>
        </div>

      </div>
    </div>
  );
};

export default withTranslation()(OptionEatIn);
